import {ChangeEvent, useEffect, useState} from "react";
import {TextField} from "@mui/material";
import style from "./WhiteLabel.module.scss";
import saveIcon from "../../../assets/svg/save.svg";

import {useApi} from "../../../providers/api.provider";
import {useUser} from "../../../providers/user.provider";
import {useGuest} from "../../../providers/guest.provider";
import {ESnackBarType} from "../../ui/SnackBar/SnackBar";

type TWhiteLabel = {
	defaultUrl: string;
	externalUrl: string;
	id?: number | null;
}

const WhiteLabel = () => {
	const api = useApi();
	const {user, setLoading} = useUser();
	const {setActiveSnackBar} = useGuest();
	const [stateDisabled, setStateDisabled] = useState<boolean>(true);
	const [isEdit, setIsEdit] = useState<boolean>(false);
	const [whiteLabelForm, setWhiteLabelForm] = useState<TWhiteLabel>({
		defaultUrl: "",
		externalUrl: "",
		id: null,
	});

	const [errors, setErrors] = useState<TWhiteLabel>({
		defaultUrl: "",
		externalUrl: "",
	});


	const handleClickSave = async () => {
		if (validateForm(whiteLabelForm)) {
			setLoading(true);
			await api.whiteLabel
				.create(whiteLabelForm)
				.then((res) => {
					// clearForm();
					setActiveSnackBar({
						state: true,
						name: ESnackBarType.success,
						message: "Successfully saved",
					});
				})
				.catch((res) => {
					setLoading(false);
					// TODO - Need to modify error handling
					let message = "Error occurred";
					setActiveSnackBar({
						state: true,
						name: ESnackBarType.error,
						message,
					});
				});
			setLoading(false);
		}
	};

	const handleClickUpdate = async () => {
		console.log('update', whiteLabelForm);
		if (validateForm(whiteLabelForm) && whiteLabelForm.id) {
			setLoading(true);
			const {defaultUrl, externalUrl} = whiteLabelForm;
			await api.whiteLabel
				.update(whiteLabelForm.id, {defaultUrl, externalUrl})
				.then((res) => {
					// clearForm();
					setActiveSnackBar({
						state: true,
						name: ESnackBarType.success,
						message: "Successfully updated",
					});
				})
				.catch((res) => {
					setLoading(false);
					// TODO - Need to modify error handling
					let message = "Error occurred";
					setActiveSnackBar({
						state: true,
						name: ESnackBarType.error,
						message,
					});
				});
			setLoading(false);
		}
	};

	const handleChangeInput = (
		event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
	) => {
		const value = event.target.value.trim();
		let form = {...whiteLabelForm};
		switch (event.target.id) {
			case "defaultUrl":
				form.defaultUrl = value;
				break;
			case "externalUrl":
				form.externalUrl = value;
				break;
		}
		setWhiteLabelForm(form);
		validateForm(form);
	};

	useEffect(() => {
		if (
			whiteLabelForm.defaultUrl &&
			whiteLabelForm.externalUrl &&
			!checkFormHasErrors(errors)
		) {
			setStateDisabled(false);
			validateForm(whiteLabelForm);
		} else {
			setStateDisabled(true);
		}
	}, [whiteLabelForm]);

	useEffect(() => {
		if(user.whiteLabel) {
			setWhiteLabelForm({
				...whiteLabelForm,
				externalUrl: user.whiteLabel.domain,
				defaultUrl: user.whiteLabel.path,
				id: user.whiteLabel.id,
			})
			setIsEdit(true);
		}
	}, [user]);

	const checkFormHasErrors = (obj: any) => {
		let arr = [];
		for (let key of Object.keys(obj)) {
			arr.push(obj[key]);
		}
		return arr.findIndex((el) => el.length > 0) !== -1;
	};

	const validateForm = (form: TWhiteLabel): any => {
		const errs = {...errors};
		let res = true;
		const regExpURLDefault = /^https:\/\/[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})*\/[A-Za-z0-9]+$/;
		// const regExpURLExternal = /^https:\/\/[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})*\/[A-Za-z0-9]+$/;


		if (!form.defaultUrl || form.defaultUrl.length === 0) {
			errs.defaultUrl = "Default URL is required!";
			res = false;
		} else {
			errs.defaultUrl = "";
		}

		if (!form.externalUrl || form.externalUrl.length === 0) {
			errs.externalUrl = "External URL is required!";
			res = false;
		} else {
			errs.externalUrl = "";
		}

		if (!regExpURLDefault.test(form.defaultUrl)) {
			errs.defaultUrl = "Default URL is invalid!";
			res = false;
		}

		/*if (!regExpURLExternal.test(form.externalUrl)) {
			errs.externalUrl = "External URL is invalid!";
			res = false;
		}*/

		setErrors(errs);
		return res;
	};

	const clearForm = () => {
		setWhiteLabelForm({
			...whiteLabelForm,
			defaultUrl: "",
			externalUrl: "",
		});
	};

	const SaveUpdateBtn = () => {
		if (isEdit) {
			return (
				<button
					type={"submit"}
					className={"btn icon icon__center btn_desktop"}
					disabled={stateDisabled}
					onClick={handleClickUpdate}
				>
					<img
						src={saveIcon}
						alt="save"
						aria-hidden="true"
						role="presentation"
					/>
					Update
				</button>
			)
		} else {
			return (
				<button
					type={"submit"}
					className={"btn icon icon__center btn_desktop"}
					disabled={stateDisabled}
					onClick={handleClickSave}
				>
					<img
						src={saveIcon}
						alt="save"
						aria-hidden="true"
						role="presentation"
					/>
					Save
				</button>
			)
		}

	}

	return (
		<>
			<section className={`bg-gray_light account-edit`}>
				<div className={`${style.container}`}>
					<div className={`${style.acc_edit__wrapper}  edit-card`}>
						<h2
							className="text-center ff-gilroy"
							style={{marginBottom: 20, fontSize: "1.3rem"}}
						>
							White Label
						</h2>
						<div className={"mb-10 flex-1"}>
							<div className={`${style.white_label_item}`}>
								<span>1</span>
								<p>Where the first step is to open their domain management and follow to DNS settings.</p>
							</div>
							<div className={`${style.white_label_item}`}>
								<span>2</span>
								<p>Second is to add A record with the following parameters: 192.168.0.1</p>
							</div>
							<div className={`${style.white_label_item}`}>
								<span>3</span>
								<p>The third is to add the default URL in the field below. Then to enter the External domain.</p>
							</div>
							<div className={`${style.white_label_item}`}>
								<span>4</span>
								<p>Then to pass the domain validation by entering the validation code in the HTML header of their web site.</p>
							</div>
							<TextField
								id="defaultUrl"
								name="defaultUrl"
								label="Default URL"
								value={whiteLabelForm.defaultUrl}
								helperText={errors.defaultUrl}
								error={!!errors.defaultUrl}
								onChange={handleChangeInput}
								type="text"
								variant="outlined"
							/>
							<TextField
								id="externalUrl"
								name="externalUrl"
								label="External URL"
								value={whiteLabelForm.externalUrl}
								onChange={handleChangeInput}
								type="text"
								helperText={errors.externalUrl}
								error={!!errors.externalUrl}
								variant="outlined"
							/>
						</div>
						<SaveUpdateBtn/>
					</div>
				</div>
			</section>
		</>
	);
};

export default WhiteLabel;
